import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Configuration du client React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (anciennement cacheTime)
      retry: (failureCount, error: any) => {
        // Ne pas refaire la requête si erreur d'authentification
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          return false;
        }
        // Retry maximum 3 fois pour les autres erreurs
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 1,
    },
  },
});

interface ReactQueryProviderProps {
  children: React.ReactNode;
}

const ReactQueryProvider: React.FC<ReactQueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* DevTools désactivés pour éviter la dépendance manquante */}
    </QueryClientProvider>
  );
};

export default ReactQueryProvider;
